import React, { ReactElement } from 'react';
import { StyleSheet } from 'react-native';

export type CloneProps<T> = {
  children: ReactElement;
} & any;

/**
 * @deprecated Any reason to continue using it?
 */
export const Clone = <T extends object>({ children, style, ...props }: CloneProps<T>) => {
  return React.cloneElement(React.Children.only(children), {
    style: StyleSheet.compose(StyleSheet.flatten(style), children.props.style),
    ...props,
  });
};
